import { YOY_BENEFICIARIES, YOY_SPEND_CR, YOY_TREES } from "./timeseries";
import { PILLARS } from "./pillars";

export const FY_LIST = YOY_BENEFICIARIES.map((r) => r.fy);
export const DEFAULT_FY = FY_LIST[FY_LIST.length - 1];

const PILLAR_IDS = PILLARS.map((p) => p.id);

// Per-FY structural metrics (states/districts/partners/economic potential)
const PER_FY_STRUCT = {
  "FY 21-22": { states:  4, districts:  9, partners:  4, econPotentialCr: 20 },
  "FY 22-23": { states:  7, districts: 16, partners:  7, econPotentialCr: 40 },
  "FY 23-24": { states: 11, districts: 24, partners:  9, econPotentialCr: 65 },
  "FY 24-25": { states: 14, districts: 34, partners: 11, econPotentialCr: 95 },
};

function pillarTotals(row) {
  return row ? PILLAR_IDS.reduce((s, id) => s + (row[id] || 0), 0) : 0;
}

export function getSnapshot(fy) {
  const idx = FY_LIST.indexOf(fy);
  const prevFy = idx > 0 ? FY_LIST[idx - 1] : null;
  const ben      = YOY_BENEFICIARIES.find((r) => r.fy === fy);
  const prevBen  = prevFy ? YOY_BENEFICIARIES.find((r) => r.fy === prevFy) : null;
  const spend    = YOY_SPEND_CR.find((r) => r.fy === fy);
  const prevSpd  = prevFy ? YOY_SPEND_CR.find((r) => r.fy === prevFy) : null;
  const trees    = YOY_TREES.find((r) => r.fy === fy);
  const prevTr   = prevFy ? YOY_TREES.find((r) => r.fy === prevFy) : null;
  const s        = PER_FY_STRUCT[fy] || {};
  const sp       = prevFy ? PER_FY_STRUCT[prevFy] : {};

  return {
    fy,
    headline: {
      beneficiaries:   { value: pillarTotals(ben),     prev: pillarTotals(prevBen) || null },
      states:          { value: s.states,              prev: sp.states ?? null },
      districts:       { value: s.districts,           prev: sp.districts ?? null },
      partners:        { value: s.partners,            prev: sp.partners ?? null },
      programSpendCr:  { value: spend?.spend ?? 0,     prev: prevSpd?.spend ?? null,    unit: "₹ Cr" },
      econPotentialCr: { value: s.econPotentialCr,     prev: sp.econPotentialCr ?? null, unit: "₹ Cr" },
      treesPlanted:    { value: trees?.trees ?? 0,     prev: prevTr?.trees ?? null },
      co2Tonnes:       {
        value: trees?.trees ? Math.round(trees.trees * 0.85) : 0,
        prev:  prevTr?.trees ? Math.round(prevTr.trees * 0.85) : null,
        unit: "t",
      },
    },
    pillar: PILLAR_IDS.reduce((acc, id) => { acc[id] = ben?.[id] ?? 0; return acc; }, {}),
  };
}
